import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import userDashItems from "../../data/UserDashItems.json"
import { useTranslation } from 'react-i18next';
import { CountBadge } from '../../components/common/NumberBadge';

export default function UserDashboardList({ ordersCount, paymentCount, CartCount, FavCount }) {
    const location = useLocation();
    const [selectedDashItem, setSelectedDashItem] = useState("");
    const { i18n } = useTranslation();

    // Set selectedDashItem based on the current location
    useEffect(() => {
        // Extract the pathname from the location object
        const pathname = location.pathname;
        setSelectedDashItem(pathname);
    }, [location]);


    return (
        <>
            {
                userDashItems.map((item, index) => (
                    <li
                        key={index}
                        className={`${!item.activeLink && "d-none"} list-group-item list-group-item-action ps-2 ${selectedDashItem === "/" + i18n.language + item.link ? 'active' : ''}`} aria-current={selectedDashItem === "/" + i18n.language + item.link && "true"}>
                        <Link to={"/" + i18n.language + item.link} className={`d-block text-decoration-none text-black ${item.status} ${selectedDashItem === "/" + i18n.language + item.link ? 'text-white' : ''}`} >
                            {i18n.language === "ar" ? item.itemNameAr : item.itemNameEn}

                            {item.itemCount === "ordersCount" ?
                                <CountBadge
                                    itemCount={ordersCount}
                                /> : item.itemCount === "paymentCount" ?
                                    <CountBadge
                                        itemCount={paymentCount}
                                    /> : item.itemCount === "CartCount" ?
                                        <CountBadge
                                            itemCount={CartCount}
                                        /> : item.itemCount === "FavCount" ?
                                            <CountBadge
                                                itemCount={FavCount}
                                            /> : ""}

                        </Link>
                    </li>
                ))
            }
        </>

    )
}
